import DocumentMeta from 'react-document-meta';
import './tokens.css';
import Navigation from './1.navigation/index';
import MainVisual from './2.mainVisual/index';
import Logo from './3.logo/index';
import SchoolMap from './schoolMap/index';
import Number from './number/index';
import Story from './story/index';
import Point from './6.point/index';
// 「美容業界特化（比較表）」セクションは一旦非表示。実装は src/pages/home/reason/ に残置。
// import Reason from './reason/index';
import Students from './students/index';
// 「その他の機能」セクションは一旦非表示。実装は src/pages/home/9.functions/ に残置。
// import Functions from './9.functions/index';
import Download from './7.download/index';
import Footer from './10.footer/index';
import { useRef } from 'react';

const Home = () => {

  const storyRef = useRef(null);
  const pointRef = useRef(null);

  const scrollTo = (ref: any) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const meta = {
    title: "サロン様向けサービス | 株式会社memorii（memorii works）新卒採用支援",
    description: "株式会社memoriiが提供する『memorii works』は、サロン様向けの新卒採用支援サービスです。美容学生とのマッチング、求人掲載、応募管理まで一括でサポートします。",
    canonical: "https://memorii-works.com/company",
    meta: {
      charset: "utf-8",
      name: {
        robots: "index,follow",
        "twitter:card": "summary_large_image",
        "twitter:title": "サロン様向けサービス | memorii works",
        "twitter:description": "美容学生とのマッチング、求人掲載、応募管理まで一括でサポート。",
        "twitter:image": "https://memorii-works.com/ogp.png",
      },
      property: {
        "og:title": "サロン様向けサービス | memorii works",
        "og:description": "美容学生とのマッチング、求人掲載、応募管理まで一括でサポート。",
        "og:url": "https://memorii-works.com/company",
        "og:type": "website",
        "og:image": "https://memorii-works.com/ogp.png",
      },
    }
  };
  return (
    <>
    <DocumentMeta {...meta}>
      <Navigation
        onScrollToProblem={() => scrollTo(storyRef)}
        onScrollToService={() => scrollTo(storyRef)}
        onScrollToPoint={() => scrollTo(pointRef)}
      />
      <MainVisual />
      <SchoolMap />
      <Number />
      <section ref={storyRef}>
        <Story />
      </section>
      <section ref={pointRef}>
        <Point />
      </section>
      <Students />
      <Logo lead="多くの美容室・サロン様にご利用いただいています" />
      <Download />
      <Footer />
    </DocumentMeta>
    </>
  );
}


export default Home;
